import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findForeigners = (headers, params) => {
    let query = buildQuery(params, ["email", "passportNo", "fullName"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/foreigners${query}`, {
        headers
    })
}
